import React, { useState } from 'react';
import { MainContainer, TopContainerWrapper } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { TabBottomLine, TabWrapper, Heading, ManagerCard, PerformanceMain, BorderBottom,ScrollableContainer } from './styles';
import { Table } from '../common/commonStyles';
import { ImageUrl } from "../../utils/constants";
import BarChart from '../common/Manager/BarChart';
import { generateDummyData, getInitials } from '../../utils/methods';
import { AdminInsightsIcon, AdminRightArrowIcon, RecognitionOverviewIcon } from '../../utils/icons';
import { NameInitials } from '../Manager/styles';
import {useHistory} from 'react-router-dom';

// const dummyOverviewData = [
//   { month: 'Growth', members: generateDummyData(15), icon:"",bg:""},
//   { month: 'Well Done', members: generateDummyData(15), icon:"",bg:""},
//   { month: 'Quality', members: generateDummyData(15), icon:"", bg:"" },
//   { month: 'Gratitude', members: generateDummyData(15), icon:"", bg:"" },
//   { month: 'Loyalty', members: generateDummyData(15), icon:"", bg:"" },
//   { month: 'More with Less', members: generateDummyData(15), icon:"", bg:"" },
//   { month: 'Passion', members: generateDummyData(15), icon:"", bg:"" },
//   { month: 'Growth', members: generateDummyData(15), icon:"", bg:"" },
//   { month: 'Collaboration', members: generateDummyData(15), icon:"", bg:"" }
// ];

const Insights = ({selectedOption,monthOption,quarterlyOptions, getColor, selectedFilter, setInsightUser, topLowPerformingUsers, getRecognitionReceivedUsers, geRecognitionGivenUsers, fetchInsightTabAPI, companyId, getRecognitionOverview, setPageNumberPaginationReceived, pageNumberReceived, getRecognitionReceivedUsersData, pageNumberGiven, setPageNumberPaginationGiver, geRecognitionGivenUsersData, setPageNumberReceived, setPageNumberGiven, getInsightUser }) => {

  const [activeTab, setActiveTab] = useState(getInsightUser);
  const [showTopRecogntion, setShowTopRecogntion] = useState(false);
  const [showEliteRecogntion, setShowEliteRecogntion] = useState(false);
  const [showEmployeeTopRecogntion, setShowEmployeeTopRecogntion] = useState(false);
  const [showEmployeeEliteRecogntion, setShowEmployeeEliteRecogntion] = useState(false);
  const [showAll, setShowAll] = useState(false);  


  const history = useHistory();

  const handleRedirect = (id) => {
    history.push(`/company/people/${id}/personal-profile`);
  };

  const toggleShowTopRecognition = () => {
    setShowTopRecogntion(!showTopRecogntion);
  };

  const toggleShowEmployeeTopRecognition = () => {
    setShowEmployeeTopRecogntion(!showEmployeeTopRecogntion);
  };


  const toggleShowEliteRecognition = () => {
    setShowEliteRecogntion(!showEliteRecogntion);
  };

  const toggleShowEmployeeEliteRecognition = () => {
    setShowEmployeeEliteRecogntion(!showEmployeeEliteRecogntion);
  };

  const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array?.length; i += chunkSize) {
      result.push(array?.slice(i, i + chunkSize));
    }
    return result;
  };

  const handleShowMore = (month) => {
    setShowAll((prevState) => ({
      ...prevState,
      [month]: true, // Set to true to show all rows for the month
    }));
  };

  // function getColorByIndex(index) {
  //   // Define an array of colors or generate colors dynamically
  //   const colors = ["#75B084","#92A4DA","#BE7D9C", "#DA92C8", "#DA9B6C", "#75B084"];
  
  //   // Return the color based on the index, repeating if necessary
  //   return colors[index % colors.length];
  // }

  const setUser = (value) =>{
    // const currentMonth = new Date().getMonth() + 1;
    setActiveTab(value)
    setInsightUser(value)
    setPageNumberReceived(1)
    setPageNumberGiven(1)
    let monthInterval = selectedFilter === "Monthly" ? "month" : selectedFilter === "Quarterly" ? "quarter" : "year";
    let index = selectedFilter === "Monthly" ? monthOption.indexOf(selectedOption) + 1 : selectedFilter === "Quarterly" ? `q${quarterlyOptions.indexOf(selectedOption) + 1}` : selectedOption;

    fetchInsightTabAPI(value, companyId,monthInterval,index)
  }

  const RecognitionOverviewCard = (data ) => (
    <>{data.map((monthData, index) => (
      <div className={selectedFilter === "Quarterly" ? 'quarterly' :'month'} style={{ display: "block" }} key={index}>
        <Table  isImageSize={"24px"}  isMinHeight={"533px"} padding="8px 0" insight headingIconBg={monthData?.recognition_color_value}>
          <div className='heading'>
            <span className='icon' ><img src={ImageUrl+"/"+monthData?.image} alt="profile-img"/></span>
            {monthData.core_value}
          </div>
          <div className='type'>
            <div className='name'>Employees</div>
            <div className='value'>Received</div>
          </div>
          <ScrollableContainer
            height={showAll[monthData?.core_value] ? "380px" : "380px"}
            showAllRows={showAll[monthData?.core_value]}
          >
            {monthData.users.slice(0, showAll[monthData.core_value] ? monthData.users.length : 5).map((data, memberIndex) => (
              <div className='item' key={memberIndex}>
                { data?.profile_image !== "profile-Image/default.png" ? <div className="profile">
                  <img src={ImageUrl + "/" + data?.profile_image} alt={data.user_name} />
                </div>: 
                  <NameInitials style={{marginRight:"8px"}} id="name-initials">
                    {getInitials(data?.user_name)}
                  </NameInitials> }
                <div className='name'>{data.user_name}</div>
                <div className='value'>{data.recognition_count}</div>
              </div>
            ))}
          </ScrollableContainer>
          {monthData.users.length > 6 && !showAll[monthData.core_value] && (
            <div className="showmore">
              <div
                className="button"
                onClick={() => handleShowMore(monthData.core_value)}
              >
                Show More
              </div>
            </div>
          )}
        </Table>
      </div>
    ))}
    </>
  )

  const transformUsers=(top_recognized)=> (
    top_recognized?.map((user) => ({
      full_name: user.user_name,
      image: user?.profile_image,
      total_recognitions: user.recognition_count
    }))
  )

  const onScrollReceived = (e) => {
  
    const isBottom =
      Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight-1)||Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight);
    window.console.log("testinggg getRecognitionReceivedUsers",isBottom,Math.round(e.target.clientHeight-1),Math.round(e.target.scrollHeight - e.target.scrollTop), getRecognitionReceivedUsersData, getRecognitionReceivedUsers);
    if (
      isBottom &&
      getRecognitionReceivedUsersData?.length < getRecognitionReceivedUsers?.pagination?.total_users
    ) {
      setPageNumberPaginationReceived(pageNumberReceived + 1); // Increment page number correctly
    }
  };

  const onScrollGiven = (e) => {
  
    const isBottom =
      Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight-1);
    // window.console.log("testinggg", isBottom,  Math.round(e.target.scrollHeight - e.target.scrollTop), Math.round(e.target.clientHeight-1));
    if (
      isBottom &&
      geRecognitionGivenUsersData?.length < geRecognitionGivenUsers?.pagination?.total_users
    ) {
      setPageNumberPaginationGiver(pageNumberGiven + 1); // Increment page number correctly
    }
  };

  const managerView = () => {
    const topdepartmentChunks = chunkArray(topLowPerformingUsers?.manager_list, 4);
    const displayedChunks = showAll ? topdepartmentChunks : topdepartmentChunks?.slice(0, 3);

    const topPerformer= transformUsers(topLowPerformingUsers?.top_recognized)
    const lowPerformer= transformUsers(topLowPerformingUsers?.least_recognized)
    const colors = ["#FCF7F0", "#F2F5FB", "#F1F8F2", "#FBE8E8"];
    return(
      <>
        <BarChart total={topLowPerformingUsers?.total_top_recognized} widthType={"full"} data={topPerformer} id={"top"} totalText={"Recognition Received"} heading={"Top Performing Managers"} barColor={"#BDDDC2"} circleColor={"#418856"} circleBorderColor={"#91C49D"}/>
        <Table isMinHeight={"0px"} paddingM={showAll && generateDummyData(15).length > 12&&"16px 8px 8px 16px"} padding="8px 0" insight margin="20px 0 20px 0" height={showAll && generateDummyData(15).length > 12?"290px":''} scroll={showAll && generateDummyData(15).length}>
          <div className='heading'>
          Managers ({topLowPerformingUsers?.manager_list?.length})
          </div>
          <div className='manager-wrap'>
            {displayedChunks?.map((chunk, chunkIndex) => (
              <div key={chunkIndex} className='wrap'>
                {chunk.map((data, index) => (
                  <ManagerCard   onClick={() => handleRedirect(data?.uid)} key={index} background={colors[Math.floor(Math.random() * colors.length)]}>
                    {  data?.profile_image !== "profile-Image/default.png" ? <div className='profile'>
                      <img src={ImageUrl + "/" + data?.profile_image} />
                    </div> :  <NameInitials style={{marginRight:"12px"}}  id="name-initials">
                      {getInitials(data?.user_name)}
                    </NameInitials>   }
                    <div className='name'>{data?.user_name}</div>
                    <div className='arrow'>
                      {AdminRightArrowIcon("#F37A65")}
                    </div>
                  </ManagerCard>
                ))}
                {chunkIndex !== displayedChunks.length - 1 && (
                  <div style={{ height: "1px", width: "100%", background: "#EFEFEF", marginTop:"1px",marginBottom:"8px" }}></div>
                )}
              </div>
            ))}
          </div>
          {!showAll && topLowPerformingUsers?.manager_list?.length > 12 && (
            <div className='showmore'>
              <div className='button' onClick={() => setShowAll(true)}>Show More</div>
            </div>
          )}
        </Table>

        <Heading isMargin={"0px 0px 20px 0px"}>
          <div className='icon'>
            {AdminInsightsIcon()}
          </div>
            Woliba Insights
        </Heading>
        <div className='top-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">Most Recognized Managers</div>
            <div className="type">
              <div className="name">Managers</div>
              <div className="value">Received</div>
            </div>
            <ScrollableContainer
              height={showTopRecogntion ? "380px" : "330px"}
              showAllRows={showTopRecogntion}
              onScroll={(e)=>onScrollReceived(e)}
            >
              {getRecognitionReceivedUsersData?.length > 0 ? (getRecognitionReceivedUsersData?.map((data, index) => (
                <div className="item" key={index}>
                  { data?.profile_image !== "profile-Image/default.png" ? <div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data.user_name} />
                  </div>: 
                    <NameInitials style={{marginRight:"8px"}} id="name-initials">
                      {getInitials(data?.user_name)}
                    </NameInitials> }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.recognition_count}</div>
                </div>
              ))):(<div className="no-data">No Data Found</div> )}
            </ScrollableContainer>
            {getRecognitionReceivedUsersData?.length > 5 && !showTopRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowTopRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>

        </div>
        <div className='low-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">Most Givers of Recognition</div>
            <div className="type">
              <div className="name">Managers</div>
              <div className="value">Given</div>
            </div>
            <ScrollableContainer
              height={showEliteRecogntion ? "380px" : "330px"}
              showAllRows={showEliteRecogntion}
              onScroll={(e)=>onScrollGiven(e)}
            >
              {geRecognitionGivenUsersData?.length > 0 ? (geRecognitionGivenUsersData?.map((data, index) => (
                <div className="item" key={index}>
                  { data?.profile_image !== "profile-Image/default.png" ? <div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data.user_name} />
                  </div>: 
                    <NameInitials style={{marginRight:"8px"}} id="name-initials">
                      {getInitials(data?.user_name)}
                    </NameInitials> }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.recognition_count}</div>
                </div>
              ))):(<div className="no-data">No Data Found</div> )}
            </ScrollableContainer>
            {geRecognitionGivenUsersData?.length > 5 && !showEliteRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowEliteRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>
          
        </div>
        <BarChart total={topLowPerformingUsers?.total_least_recognized} widthType={"full"} data={lowPerformer} totalText={"Recognition Received"} heading={"Least Recognized Managers"} style={{marginTop:"20px"}} barColor={"#EEB3B4"} circleColor={"#C13D4D"} circleBorderColor={"#E4888C"}/>
      </>)
  }

  const emlpoyeeView = () => {

    // const topdepartmentChunks = chunkArray(generateDummyData(15), 4);
    // const displayedChunks = showAll ? topdepartmentChunks : topdepartmentChunks.slice(0, 3);
    const topPerformer= transformUsers(topLowPerformingUsers?.top_recognized)
    const lowPerformer= transformUsers(topLowPerformingUsers?.least_recognized)

    
    return(
      <>
        <BarChart total={topLowPerformingUsers?.total_top_recognized} widthType={"full"} data={topPerformer} id={"top"} totalText={"Recognition Received"} heading={"Top 10 Performing Employees | Overall"} barColor={"#D3DEF2"} circleColor={"#8391D1"} circleBorderColor={"#B9C8E8"}/>
        <Heading>
          <div className='icon'>
            {AdminInsightsIcon()}
          </div>
            Woliba Insights
        </Heading>

        <div className='top-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">  Most Recognized Employees</div>
            <div className="type">
              <div className="name">Employees</div>
              <div className="value">Received</div>
            </div>
            <ScrollableContainer
              height={showEmployeeTopRecogntion ? "380px" : "330px"}
              showAllRows={showEmployeeTopRecogntion}
              onScroll={(e)=>onScrollReceived(e)}
            >
              {getRecognitionReceivedUsersData?.length > 0 ? (getRecognitionReceivedUsersData?.map((data, index) => (
                <div className="item" key={index}>
                  { data?.profile_image !== "profile-Image/default.png" ? <div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data.user_name} />
                  </div>: 
                    <NameInitials style={{marginRight:"8px"}} id="name-initials">
                      {getInitials(data?.user_name)}
                    </NameInitials> }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.recognition_count}</div>
                </div>
              ))):( <div className="no-data">No Data Found</div> )}
            </ScrollableContainer>
            {getRecognitionReceivedUsersData?.length > 5 && !showEmployeeTopRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowEmployeeTopRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>
        </div>
        <div className='low-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">Most Givers of Recognition</div>
            <div className="type">
              <div className="name">Employees</div>
              <div className="value">Given</div>
            </div>
            <ScrollableContainer
              height={showEmployeeEliteRecogntion ? "380px" : "330px"}
              showAllRows={showEmployeeEliteRecogntion}
              onScroll={(e)=>onScrollGiven(e)}
            >
              {geRecognitionGivenUsersData?.length > 0 ? (geRecognitionGivenUsersData?.map((data, index) => (
                <div className="item" key={index}>
                  { data?.profile_image !== "profile-Image/default.png" ? <div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data.user_name} />
                  </div>: 
                    <NameInitials style={{marginRight:"8px"}} id="name-initials">
                      {getInitials(data?.user_name)}
                    </NameInitials> }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.recognition_count}</div>
                </div>
              ))): 
                (
                  <div className="no-data">No Data Found</div> 
                )
              }
            </ScrollableContainer>
            {geRecognitionGivenUsersData?.length > 5 && !showEmployeeEliteRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowEmployeeEliteRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>
        </div>
        <BarChart total={topLowPerformingUsers?.total_least_recognized} widthType={"full"} data={lowPerformer} totalText={"Recognition Received"} heading={"Employees Requiring Improvement"} style={{marginTop:"20px"}} barColor={"#EEB3B4"} circleColor={"#C13D4D"} circleBorderColor={"#E4888C"} id={"least"}/>

        {getRecognitionOverview?.length ? <Heading>
          <div className='icon'>
            {RecognitionOverviewIcon()}
            {/* <img src={ImageUrl + "/admin-recognition/icons/star.svg"} /> */}
          </div>
          Recognition Overview
        </Heading>: null}
        <PerformanceMain>
          {RecognitionOverviewCard(getRecognitionOverview)}
        </PerformanceMain>
      </>)
  }
  
  return (
    <MainContainer margin>
      <TopContainerWrapper style={{ flexWrap: "wrap" }}>
        <TabWrapper>
          <TabBottomLine active={activeTab === 'employee'} background={getColor} onClick={() => setUser('employee')}>
          Employees
            <BorderBottom active={activeTab === 'employee'} background={getColor} />
          </TabBottomLine>
          <TabBottomLine active={activeTab === 'manager'} background={getColor} onClick={() => setUser('manager')}>
          Managers
            <BorderBottom active={activeTab === 'manager'} background={getColor} />
          </TabBottomLine>
        </TabWrapper>
        {activeTab === "employee" ?  emlpoyeeView() : null}
        {activeTab === "manager" ?  managerView() : null}
      </TopContainerWrapper>
    </MainContainer>
  );
};

Insights.propTypes = {
  getColor: PropTypes.func.isRequired,
  selectedFilter:PropTypes.string,
  setInsightUser: PropTypes.func,
  topLowPerformingUsers: PropTypes.array,
  getRecognitionReceivedUsers: PropTypes.array,
  geRecognitionGivenUsers: PropTypes.array,
  fetchInsightTabAPI: PropTypes.func,
  getInsightUser: PropTypes.string,
  companyId: PropTypes.number,
  selectedYear: PropTypes.number,
  getRecognitionOverview: PropTypes.array,
  setPageNumberPaginationReceived: PropTypes.func,
  pageNumberReceived: PropTypes.number,
  getRecognitionReceivedUsersData: PropTypes.array,
  setPageNumberPaginationGiver: PropTypes.func,
  pageNumberGiven: PropTypes.number,
  geRecognitionGivenUsersData: PropTypes.func,
  setPageNumberReceived: PropTypes.func,
  setPageNumberGiven: PropTypes.func,
  selectedOption: PropTypes.string,
  monthOption: PropTypes.array,
  quarterlyOptions: PropTypes.array,
};

export default Insights;